
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-785504f8\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./menu.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./menu.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-785504f8\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./menu.vue.html"),
  /* scopeId */
  "data-v-785504f8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/menu/menu.vue.html
// module id = B7ns
// module chunks = 2